import { render, staticRenderFns } from "./ChartTwo.vue?vue&type=template&id=07a36651&scoped=true"
import script from "./ChartTwo.vue?vue&type=script&lang=js"
export * from "./ChartTwo.vue?vue&type=script&lang=js"
import style0 from "./ChartTwo.vue?vue&type=style&index=0&id=07a36651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a36651",
  null
  
)

export default component.exports